import {Dispatchable, Dispatcher} from "../../../../stem-core/base/Dispatcher";


export interface JourneyAction {
    type?: string;
    callback?: string;
    blinkAction?: string;
    every?: boolean;
    lazy?: boolean;
    selector?: string;
    panel?: number | string;
    panelType?: string;
    gateType?: string;
    context?: unknown[] | Record<string, unknown>;
    [key: string]: unknown;
}

export interface JourneyOptions {
    action?: JourneyAction | JourneyAction[];
    throttle?: unknown;
    condition?: unknown;
    reeval?: string | string[];
    precondition?: unknown;
    type?: string;
    [key: string]: unknown;
}

export interface Journey {
    id: string | number;
    alias: string;
    options: JourneyOptions;
    priority?: number;
    weight?: number;
}

export class Condition<TOptions = any> extends Dispatchable {
    ops: Condition[] = [];
    journey: Journey;
    options: TOptions;
    requestReEval: () => void;
    cachedResult?: boolean | null;

    // requestReEval asks a reeval for the whole condition tree. Assume to be throttled already.
    constructor(journey: Journey, options: TOptions, requestReEval: () => void) {
        super();
        this.journey = journey;
        this.options = options;
        // Wrap in a lambda for each instance of Condition to avoid Stem Dispatcher's error about
        // "Can't re-register for the same callback: ...".
        this.requestReEval = () => requestReEval();
    }

    // Returns true or false if can be evaluated, null if evaluation can't be made so far.
    evaluate(): boolean | null {
        return null;
    }

    cleanup() {
        super.cleanup();
        this.ops.forEach(subCondition => subCondition.cleanup());
    }
}

// TODO @cleanup use this in more places
// Make a simple condition that is bound to this function and reevaluates when watchdog dispatches a change
export function MakeSimpleCondition<TOptions = any>(
    func: (options: TOptions, journey: Journey, condition: Condition<TOptions>) => any,
    watchdog?: Dispatchable | Dispatcher,
) {
    return class SimpleCondition extends Condition<TOptions> {
        constructor(journey: Journey, options: TOptions, requestReEval: () => void) {
            super(journey, options, requestReEval);

            if (watchdog instanceof Dispatchable) {
                this.attachChangeListener(watchdog, this.requestReEval);
            }

            if (watchdog instanceof Dispatcher) {
                this.attachListener(watchdog, this.requestReEval);
            }
        }

        evaluate() {
            return func(this.options, this.journey, this);
        }
    }
}
